"use client";
import { cn } from "@/lib/utils";
import { motion } from "framer-motion";
import { CSSProperties } from "react";

type ComicTextProps = {
  children: string;
  className?: string;
  style?: CSSProperties;
  fontSize?: number;
};

export function ComicText({
  children,
  className,
  style,
  fontSize = 5,
}: ComicTextProps) {
  if (typeof children !== "string") {
    throw new Error("children must be a string");
  }

  const dotColor = "#EF4444";
  const backgroundColor = "#CC7722";//"#FACC15";

  return (
    <motion.div
      className={cn("select-none text-center mb-2 text-orange-400/70", className)}
      style={{
        fontSize: `${fontSize}rem`,
        fontFamily: "'Bangers', 'Comic Sans MS', 'Impact', sans-serif",
        fontWeight: "900",
        WebkitTextStroke: `${fontSize * 0.35}px #000000`, // Thick black outline
        transform: "skewX(-10deg)",
        textTransform: "uppercase",
        // filter: `
        //   drop-shadow(5px 5px 0.5px rgb(246, 242, 242)) 
        //   drop-shadow(3px 3px 0px ${dotColor})
        // `,
        filter: `
          drop-shadow(5px 5px 0.5px rgb(246, 242, 242)) 
          drop-shadow(3px 3px 1px  rgb(87, 8, 244)) 
        `,
        backgroundColor: backgroundColor,
        backgroundImage: `radial-gradient(circle at 1px 1px, ${dotColor} 1px, transparent 0)`,
        backgroundSize: "8px 8px",
        backgroundClip: "text",
        WebkitBackgroundClip: "text",
        WebkitTextFillColor: "transparent",
        ...style,
      }}
      initial={{ opacity: 0, scale: 0.8, rotate: -2 }}
      animate={{ opacity: 1, scale: 1, rotate: 0 }}
      transition={{
        duration: 0.6,
        ease: [0.175, 0.885, 0.32, 1.275],
        type: "spring",
      }}
    >
      {children}
    </motion.div>
  );
}

// Usage

// import { ComicText } from "@/components/magicui/comic-text";
// <ComicText>Comic Text</ComicText>

// export function ComicTextDemo() {
//   return (
//     <div className="space-y-8 text-center">
//       <ComicText fontSize={5}>BOOM!</ComicText>
//     </div>
//   );
// }
